<!-- stepper-grid.component.html -->
<div class="p-8 pt-0 mt-5">
  <div class="max-w-8xl mx-auto">
    <!-- Steps -->
    <div class="flex items-center justify-between relative">
      <!-- Connector Line (Background) -->
      <div class="absolute top-5 left-0 w-full h-0.5 bg-gray-300 -z-10"></div>

      <!-- Dynamic Steps -->
      @for (step of steps(); track step.id; let i = $index) {
        <div
          class="flex flex-col items-center relative"
          [class.cursor-pointer]="step.status === 'completed' || step.status === 'active'"
          (click)="navigateToStep(step)">

          <!-- Step Circle -->
          <div
            class="w-10 h-10 flex items-center justify-center rounded-full font-semibold transition-all duration-300"
            [class]="getStepClasses(step.status)">

            @if (step.status === 'completed') {
              <!-- Completed: Checkmark -->
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            } @else {
              <!-- Active or Pending: Step Number -->
              {{ step.id}}
            }
          </div>

          <!-- Step Title -->
          <div
            class="mt-2 text-xs font-medium transition-colors duration-300"
            [class]="getTitleClasses(step.status)">
            {{ step.title }}
          </div>

          <!-- Connector Line (between steps) -->
          @if (i < steps().length - 1) {
            <div
              class="absolute top-5 left-1/2 w-full h-0.5 -z-10 transition-colors duration-300"
              [class]="getConnectorClasses(step.status)">
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
